import { getAppConfig } from "config/client.config";
import _ from "lodash";

export const GET_LEARNERS = "GET_LEARNERS";
export const ADD_LEARNERS = "ADD_LEARNERS";
export const MODIFY_LEARNER = "MODIFY_LEARNER";
export const DELETE_LEARNER = "DELETE_LEARNER";

const _getLearners = (status, data, err) => {
    return {
        type: GET_LEARNERS,
        data,
        err,
        status,
    };
};

const getTeam = (direct_only) => {
    return (dispatch, getState, Request) => {
        let thisLicense = getState().auth.user.license.license_type;
        if (
            thisLicense === "TeamLead" ||
            thisLicense === "Creator" ||
            thisLicense === "Admin" ||
            thisLicense === "Inductor" ||
            thisLicense === "FreeInductor"
        ) {
            let getTeamPath = getAppConfig().endpoints.adminDataPaths.getTeamPath.replace(
                ":team",
                "false"
            );
            return Request.fetch(getTeamPath)
                .then((response) => {
                    return response.json().then((data) => {
                        return data;
                    });
                })
                .catch((err) => {
                    return [];
                });
        } else {
            return Promise.resolve([]);
        }
    };
};

const getLearners = () => {
    return (dispatch, getState, Request) => {
        let getLearnersPath = getAppConfig().endpoints.learnerManagerPaths[
            "getLearnersPath"
        ].replace(":id", getState().editingCourse._id);
        return Request.fetch(getLearnersPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(_getLearners("success", data, null));
                });
            })
            .catch((err) => {
                console.log(err);
                return dispatch(_getLearners("error", null, err));
            });
    };
};

const triggerInAppNotification = (learnerId, message, checkCaptcha) => {
    return (dispatch, getState, Request) => {
        let triggerNotificationPath = getAppConfig().endpoints
            .learnerManagerPaths["triggerNotificationPath"];
        triggerNotificationPath = _.replace(
            triggerNotificationPath,
            ":id",
            learnerId
        );
        return Request.fetch(triggerNotificationPath, {
            method: "POST",
            body: JSON.stringify({
                message: message,
                checkCaptcha: false,
            }),
        })
            .then((response) => {
                return response.json().then((data) => { });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const triggerEmailNotification = (
    emailType,
    learnerId,
    courseAssignor,
    course,
    message
) => {
    return (dispatch, getState, Request) => {
        let triggerMailPath = getAppConfig().endpoints.mailCertificatePath;
        triggerMailPath = _.replace(triggerMailPath, ":id", learnerId);

        let reqBody = {
            type: emailType,
        };

        if (course) {
            reqBody.course = course;
        }

        if (courseAssignor) {
            reqBody.assignor = courseAssignor;
        }

        if (message) {
            reqBody.message = message;
        }

        return Request.fetch(triggerMailPath, {
            method: "POST",
            body: JSON.stringify(reqBody),
        })
            .then((response) => {
                return response.json().then((data) => { });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const triggerSMSNotification = (
    emailType,
    learnerId,
    courseAssignor,
    course,
    message
) => {
    return (dispatch, getState, Request) => {
        let triggerSMSPath = getAppConfig().endpoints.learnerManagerPaths[
            "triggerSMSNotifications"
        ];

        let reqBody = {
            user: learnerId,
            type: emailType,
        };

        if (course) {
            reqBody.course = course;
        }

        if (courseAssignor) {
            reqBody.assignor = courseAssignor;
        }

        if (message) {
            reqBody.message = message;
        }

        return Request.fetch(triggerSMSPath, {
            method: "POST",
            body: JSON.stringify(reqBody),
        })
            .then((response) => {
                return response.json().then((data) => { });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const getTrainees = (userId) => {
    return (dispatch, getState, Request) => {
        let getTraineePath = getAppConfig().endpoints.adminDataPaths.getTraineesPath.replace(
            ":id",
            userId
        );
        return Request.fetch(getTraineePath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return [];
            });
    };
};

const verifyCaptcha = (captcha, count) => {
    return (dispatch, getState, Request) => {
        let verifyCaptchaPath = getAppConfig().endpoints.learnerManagerPaths[
            "verifyCaptchaPath"
        ];

        return Request.fetch(verifyCaptchaPath, {
            method: "POST",
            body: JSON.stringify({
                captcha: captcha,
                count: count,
            }),
        })
            .then((response) => {
                return response.json().then((data) => { });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const deactivateCaptcha = (captcha) => {
    return (dispatch, getState, Request) => {
        let verifyCaptchaPath = getAppConfig().endpoints.learnerManagerPaths[
            "deactivateCaptchaPath"
        ];

        return Request.fetch(verifyCaptchaPath, {
            method: "POST",
            body: JSON.stringify({
                captcha: captcha,
            }),
        })
            .then((response) => {
                return response.json().then((data) => { });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const tiggerCourseLaunchPath = (courseId) => {
    return (dispatch, getState, Request) => {
        let getCoursePath = getAppConfig().endpoints.learnerManagerPaths[
            "tiggerCourseLaunchPath"
        ].replace(":course_id", courseId)
        return Request.fetch(getCoursePath, {
            method: "POST"
        }).then((response) => {
            return response.json();
        }).catch(
            (err) => {
                return Promise.reject(err);
            });
    };
}
class LearnerManagerAction {
    static getLearners = getLearners;
    static triggerInAppNotification = triggerInAppNotification;
    static getTeam = getTeam;
    static triggerEmailNotification = triggerEmailNotification;
    static triggerSMSNotification = triggerSMSNotification;
    static getTrainees = getTrainees;
    static verifyCaptcha = verifyCaptcha;
    static deactivateCaptcha = deactivateCaptcha;
    static tiggerCourseLaunchPath = tiggerCourseLaunchPath;
}

export default LearnerManagerAction;
